import React from 'react';

import { trans } from '@spotahome/soyuz/client';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';

import './AboutMission.scss';

const AboutMission = () => (
  <div className="wrapper">
    <SectionHeading text={trans('about-us.mission.title')} />

    <div className="two-cols">
      <div className="about-mission__item">
        <h3 className="about-mission__item-title mb-xl">
          {trans('about-us.mission.item-1.title')}
        </h3>
        <p className="mb-xl">{trans('about-us.mission.item-1.paragraph-1')}</p>
        <p>{trans('about-us.mission.item-1.paragraph-2')}</p>
      </div>

      <div className="about-mission__item">
        <h3 className="about-mission__item-title mb-xl">
          {trans('about-us.mission.item-2.title')}
        </h3>
        <p className="mb-xl">{trans('about-us.mission.item-2.paragraph-1')}</p>
        <ol className="about-mission__values">
          <li className="about-mission__values-item">
            {trans('about-us.mission.item-2.list-1')}
          </li>
          <li className="about-mission__values-item">
            {trans('about-us.mission.item-2.list-2')}
          </li>
          <li className="about-mission__values-item">
            {trans('about-us.mission.item-2.list-3')}
          </li>
          <li className="about-mission__values-item">
            {trans('about-us.mission.item-2.list-4')}
          </li>
          <li className="about-mission__values-item">
            {trans('about-us.mission.item-2.list-5')}
          </li>
          <li className="about-mission__values-item">
            {trans('about-us.mission.item-2.list-6')}
          </li>
          <li className="about-mission__values-item">
            {trans('about-us.mission.item-2.list-7')}
          </li>
          <li className="about-mission__values-item">
            {trans('about-us.mission.item-2.list-8')}
          </li>
        </ol>
      </div>
    </div>
  </div>
);

export default AboutMission;
